const withQueryParams = (fetchFn) => (queryContext) => {
  const { queryKey, signal } = queryContext;
  const [, params] = queryKey;
  return fetchFn(params, signal);
};
export {
  withQueryParams
};
